/**
 * useTextUtils
 *
 * Utility composable for text processing.
 * Handles HTML entity decoding for content from JSON.
 */

/**
 * Decode common HTML entities to their character equivalents
 * Used for processing JSON content that may contain entities like &nbsp;
 */
export function decodeEntities(text: string): string {
  if (!text) return ''

  return text
    .replace(/&nbsp;/g, '\u00A0') // Non-breaking space
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&mdash;/g, '-')
    .replace(/&ndash;/g, '–')
    .replace(/&hellip;/g, '…')
}

export function useTextUtils() {
  return {
    decodeEntities,
  }
}
